import React, { useState } from 'react';
import { Form, Input, Select, Button, Avatar, message } from 'antd';
import { businessCategories, countries, entityType } from '../../../config/variable';
import Flag from 'react-world-flags';
import { addUser } from '../../../api/auth';
import { useDispatch } from 'react-redux';
import { getUsers } from '../../../redux/actions/AllActions';

const { Option } = Select;

const AddUser = ({ setShowAddModel }) => {
    const [form] = Form.useForm();
    const [profilePic, setProfilePic] = useState(null);
    const [preview, setPreview] = useState(null);
    const dispatch = useDispatch();


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfilePic(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleFinish = async (values) => {
        try {
            await addUser({
                address: values?.businessAddress,
                businessCategory: values?.businessCategory,
                businessName: values?.businessName,
                city: values?.city,
                country: values?.country,
                countryCode: values?.countryCode,
                designation: values?.designation,
                email: values?.email,
                entryType: values?.entryType,
                gstNumber: values?.gstNumber,
                industryType: values?.industryType,
                name: values?.name,
                password: values?.password,
                phoneNumber: values?.phoneNumber,
                postalCode: values?.postalCode,
                state: values?.state,
                street: values?.street,
                profilePic
            })
            dispatch(getUsers());
            message.success("User created Successfully");
            setShowAddModel(false);

        
        } catch (e) {
            message.error("Creation of user is failed");
            console.log('the erroris',e)
        }  
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleFinish}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                {preview && (
                    <Avatar style={{ width: "150px", height: "150px" }} src={preview} />
                )}
            </div>

            <Form.Item label="Select Profile Pic">
                <input type="file" onChange={handleFileChange} />
            </Form.Item>

            <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please enter name' }]}>
                <Input placeholder="Enter Name" />
            </Form.Item>

            <Form.Item label="Designation" name="designation" rules={[{ required: true }]}>
                <Select placeholder="Select User Type">
                    <Option value="User">User</Option>
                    <Option value="Agent">Agent</Option>
                </Select>
            </Form.Item>

            <div className="flex">
                <Form.Item label="Country" name="countryCode" rules={[{ required: true }]}>
                    <Select placeholder="Select Country">
                        {countries.map((country, index) => (
                            <Option key={index} value={country.code}>
                                <Flag code={country.flag?.toUpperCase()} style={{ width: 20, height: 15 }} /> {country.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item label="Phone Number" name="phoneNumber" rules={[{ required: true }]}>
                    <Input type="number" placeholder="Enter phone number" />
                </Form.Item>
            </div>

            <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email' }]}>
                <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item label="Password" name="password" rules={[{ required: true }]}>
                <Input.Password placeholder="Enter Password" />
            </Form.Item>

            <Form.Item label="Business Name" name="businessName" rules={[{ required: true }]}>
                <Input placeholder="Enter business name" />
            </Form.Item>

            <Form.Item label="GST Number" name="gstNumber" rules={[{ required: true }]}>
                <Input placeholder="Enter GST Number" />
            </Form.Item>

            <Form.Item label="Entry Type" name="entryType" rules={[{ required: true }]}>
                <Select>
                    {entityType.map((entry, index) => (
                        <Option key={index} value={entry}>{entry}</Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Industry Type" name="industryType" rules={[{ required: true }]}>
                <Input placeholder="Enter Industry Type" />
            </Form.Item>

            <Form.Item label="Business Category" name="businessCategory" rules={[{ required: true }]}>
                <Select>
                    {businessCategories.map((category, index) => (
                        <Option key={index} value={category}>{category}</Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Business Address" name="businessAddress" rules={[{ required: true }]}>
                <Input.TextArea placeholder="Enter Business Address" />
            </Form.Item>

            <Form.Item label="Street" name="street" rules={[{ required: true }]}>
                <Input placeholder="Enter Street" />
            </Form.Item>

            <Form.Item label="City" name="city" rules={[{ required: true }]}>
                <Input placeholder="Enter City" />
            </Form.Item>

            <Form.Item label="State" name="state" rules={[{ required: true }]}>
                <Input placeholder="Enter State" />
            </Form.Item>

            <Form.Item label="Postal Code" name="postalCode" rules={[{ required: true }]}>
                <Input placeholder="Enter Postal Code" />
            </Form.Item>
            

            <Form.Item label="Business Country" name="country" rules={[{ required: true }]}>
                <Select>
                    {countries.map((country, index) => (
                        <Option key={index} value={country.country}>{country.country}</Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Commision" name="commision" rules={[{ required: true }]}>
                <Input placeholder="Add Commision" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Submit</Button>
            </Form.Item>
        </Form>
    );
};

export default AddUser;
